import {Component, Input, OnInit} from '@angular/core';
import {FieldService} from "../field/field.service";
import {FieldTable, FieldTableDto, Table, TableLiteDto} from "@tj/tj-dmp-lib-api";
import {
    SelectorFieldTableComponent
} from "../../../pages/etl-v1/etl-update/etl-update-design2/selector-field-table/selector-field-table.component";

@Component({
    selector: 'dmp-field-label',
    templateUrl: './field-label.component.html',
    styleUrls: ['./field-label.component.scss'],
    standalone: false
})
export class FieldLabelComponent implements OnInit {
    @Input() table: string;
    @Input() field: string;
    @Input() displayTooltip = false;
    fieldTable: FieldTableDto = null;
    tableModel: Table;
    displayHover: string = null;
  constructor(public fieldService: FieldService) { }

  ngOnInit(): void {
      this.tableModel = this.fieldService.tables.find(t => t.code === this.table);
      if (this.tableModel) {
          this.fieldTable = this.tableModel.fields.find(f => f.code === this.field) as FieldTableDto;
          if (this.displayTooltip) {
              this.displayHover = this.buildTootltip(this.tableModel, this.fieldTable);
          }
      }
  }

    private buildTootltip(table: Table, field?: FieldTable) {
        let txt = `# Table :\n`;
        if (table.label) { txt += `- Nom : ${table.label}\n`; }
        if (table.code) { txt += `- Code : ${table.code }\n`; }
        if (table.description) { txt += `- Description : ${table.description }\n`; }
        if (field) {
            txt += `# Champ :\n`;
            if (field.label) { txt += `- Nom : ${field.label}\n`; }
            if (field.code) { txt += `- Code : ${field.code }\n`; }
            txt += `- Obligatoire: ${field.notNull ? 'Oui' : 'Non' }\n`;
            if (field.description) { txt += `- Description : ${field.description }\n`; }
            if (field.categoryField) { txt += `- Catégorie : ${SelectorFieldTableComponent.getCategory(field) }\n`; }
            if (field.type) { txt += `- Type : ${SelectorFieldTableComponent.getType(field) }`; }
        }
        return txt;
    }

}
